import React, { Component } from "react";
import { Popup, GenericInput, Button } from "../../components";

class AddCategoryModal extends Component {
	state = {
		name: this.props.initialName || "",
		submitting: false,
	};

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.isOpen && !this.props.isOpen) {
			this.setState({ name: nextProps.initialName || "", submitting: false });
		}
	}

	handleSave = () => {
		const name = this.state.name.trim();
		if (!name || this.state.submitting) return;
		this.setState({ submitting: true });
		this.props.onSave(name).catch(() => {
			this.setState({ submitting: false });
		});
	};

	render() {
		if (!this.props.isOpen) {
			return null;
		}

		const { submitting } = this.state;

		return (
			<Popup
				title={this.props.initialName ? "Edit Category" : "Add Category"}
				onClose={this.props.onClose}
				hasPadding
				minWidth={500}
				buttons={[
					{
						type: "outlined",
						text: "Cancel",
						onClick: this.props.onClose,
						isActive: !submitting,
					},
					{
						type: "primary",
						text: "Save",
						onClick: this.handleSave,
						isActive: this.state.name.trim().length > 0 && !submitting,
						loading: submitting,
					},
				]}
			>
				<GenericInput
					id="categoryName"
					type="text"
					label="Category Name"
					placeholder="Enter category name"
					value={this.state.name}
					onChange={(e) => this.setState({ name: e.target.value })}
					alwaysShowLabel
				/>
			</Popup>
		);
	}
}

export default AddCategoryModal;
